<template>
    <b-card header="Worker Absence Required" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div v-if="!e_absence" class="row">
            <div class="col-12">
                <p class="font-weight-bold pt-0 mb-3">Change whether the worker is required to enter in an absence reason</p>
            </div>

            <div class="col-xl-4 form-group">
                <label class="form-label" for="genius_retention_agreed">Worker Absence Required</label>
                <p>{{ company.absence_required === 1 ? 'Yes' : 'No' }}</p>
            </div>

            <div class="col-12">
                <p class="pt-0 mb-3">
                    Disabling this option means that the company's workers no longer have to input an absence reason when submitting "0" hours.
                    This is for worker's submitting using our Genius App.
                </p>
            </div>
            
            <div class="col-12 text-right">
                <button @click="edit_form()" class="btn orcaBtn blueBtn sm_btn mb-2" style="width: auto !important;">Edit Absence Required</button>
            </div>
        </div>

        <div v-else class="row">
            <ValidationObserver ref="editChargesForm" slim tag="div" class="col-12">
                <div class="col-12">
                    <p class="font-weight-bold pt-0 mb-3">
                        Change whether the worker is required to enter in an absence reason
                    </p>
                </div>

                <div class="col-xl-4">
                    <div class="row">
                        <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_fee_margin_agreed">
                            Worker Absence Required
                        </label>
                        <div class="col-xl-4 form-group">
                            <bootstrap-toggle v-model="absenceRequiredToggle" name="absence_required"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <p class="pt-0 mb-3">
                        Disabling this option means that the company's workers no longer have to input an absence reason when submitting "0" hours.
                        This is for worker's submitting using our Genius App.
                    </p>
                </div>

                <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->  
                <div class="row mb-3 mt-2">
                  <div class="col-xl-6">
                    <button @click.prevent="cancel_form()" class="btn orcaBtn grey_bg sm_btn w-100">Cancel</button>
                  </div>
                  <div class="col-xl-6">
                    <button @click="submit_form()" type="submit" class="btn orcaBtn sm_btn w-100">Update Absence Required</button>
                  </div>
                </div>
            </ValidationObserver>   
        </div>
    </b-card>
</template>

  <script>
  import Multiselect from "vue-multiselect";
  import BootstrapToggle from 'vue-bootstrap-toggle';
  import { getChangedFields } from 'utils/utils';
  export default {
    name: "worker_absence_required",
    components: {
      Multiselect,
      BootstrapToggle
    },
    props: [
      'company'
    ],
    data() {
      return {
        e_absence: false,
        edit_absence: {},
        original_absence: {},
      }
    },
    computed: {
      absenceRequiredToggle: {
        get() {
          return Boolean(this.edit_absence.absence_required);
        },
        set(newValue) {
          this.edit_absence.absence_required = newValue ? 1 : 0;
        }
      }
    },
    methods: {
        edit_form() {
            this.edit_absence = Object.assign({}, this.company);
            this.original_absence = Object.assign({}, this.company);
            this.e_absence = true;
        },

        cancel_form() {
            this.edit_absence = {};
            this.e_absence = false;
        },

        submit_form() {
          let charges_promises = [];
          
          // Use the new function to get changed fields
          let changed_fields = [
            ...getChangedFields(this.original_absence, this.edit_absence),
          ];

          charges_promises.push(new Promise(resolve => {
            let submit_ppi = {
              company_id: this.company.id,
              absence_required: this.edit_absence.absence_required,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            }

            // save updates to database
            axios.patch(this.crmApiPath + 'company/' + this.company.id, submit_ppi).then(() => resolve());
          }));

          
          if (changed_fields.length > 0) {
            // Send changed fields through AJAX on email
            charges_promises.push(new Promise(resolve => {
              axios.post(this.crmApiPath + 'company/send_changed_email', {
                title: 'WORKER ABSENCE REQUIRED',
                company_id: this.company.id,
                changes: changed_fields,
              }).then(() => resolve());
            }));
          }


          Promise.all(charges_promises).then(() => {
            this.$bus.$emit('company::reload', {action: true});
            this.e_absence = false;  // Hide the edit form after submission
          })
        },

        handleInput() {
          this.edit_absence.default_retention_percentage = parseFloat(
            this.edit_absence.default_retention_percentage
          );
        }
    }
  }
  </script>
